// import { createSlice } from "@reduxjs/toolkit";
// import axios from "../../utils/axios";
// const backendUrl = process.env.REACT_APP_BACKEND_URL;

// const initialState = {
//   isLoading: false,
//   error: null,
//   categories: [],
//   terminalCategories: [],
//   category: null,
// };

// const slice = createSlice({
//   name: "category",
//   initialState,
//   reducers: {
//     // START LOADING
//     startLoading(state) {
//       state.isLoading = true;
//     },

//     // HAS ERROR
//     hasError(state, action) {
//       state.isLoading = false;
//       state.error = action.payload;
//     },

//     // GET CATEGORIES
//     getCategoriesSuccess(state, action) {
//       state.isLoading = false;
//       state.categories = action.payload;
//     },
//     // GET TERMINAL-SPECIFIC CATEGORIES
//     getTerminalCategoriesSuccess(state, action) {
//       state.isLoading = false;
//       state.terminalCategories = action.payload;
//     },

//     // GET CATEGORY
//     getCategorySuccess(state, action) {
//       state.isLoading = false;
//       state.category = action.payload;
//     },
//   },
// });

// // Reducer
// export default slice.reducer;

// // Actions
// // export const {
// // } = slice.actions;

// // ----------------------------------------------------------------------

// export function getCategories(levelId, venueId) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const params = new URLSearchParams({
//         levelId,
//         venueId,
//         limit: '100000',
//       });
//       const url = `${backendUrl}/categories?${params.toString()}`;
//       const response = await axios.get(url);
//       dispatch(slice.actions.getCategoriesSuccess(response.data.results));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }
// export function getTerminalCategories(levelId, venueId, isAvailableOnPos, posCart) {
//   return async (dispatch) => {
//    dispatch(slice.actions.startLoading());
//     try {
//       const params = new URLSearchParams({
//         levelId,
//         venueId,
//         limit: '100000',
//       });
//       if (isAvailableOnPos !== undefined) {
//         params.append('isAvailableOnPos', isAvailableOnPos);
//       }
//       if (posCart && posCart.type === 'web' && posCart.isOrderEdit === true) {
//         params.append('isAvailableOnWebApp', true);
//       }
//       const url = `${backendUrl}/categories?${params.toString()}`;
//       const response = await axios.get(url);
//       dispatch(slice.actions.getTerminalCategoriesSuccess(response.data.results));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }


// // ----------------------------------------------------------------------

// export function getCategory(categoryId) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get(
//         `${backendUrl}/categories/${categoryId}`
//       );
//       dispatch(slice.actions.getCategorySuccess(response.data));
//     } catch (error) {
//       console.error(error);
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }


import { createSlice } from "@reduxjs/toolkit";

import {
  getLocalizedText,
  getResolvedId,
  apiGet,
  getResults,
  getResource,
  handleApiRequest,
} from "../../utils/apiRequestV2";

const CATEGORY_ENDPOINT = "/venue/category";
const TERMINAL_CATEGORY_ENDPOINT = "/venue/category/terminal-categories";
const TERMINAL_PRODUCT_ENDPOINT = "/venue/product/terminal-products";

const initialState = {
  isLoading: false,
  error: null,
  categories: [],
  terminalCategories: [],
  category: null,
};

const slice = createSlice({
  name: "category",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getCategoriesSuccess(state, action) {
      state.isLoading = false;
      state.categories = action.payload;
    },

    getTerminalCategoriesSuccess(state, action) {
      state.isLoading = false;
      state.terminalCategories = action.payload;
    },

    getCategorySuccess(state, action) {
      state.isLoading = false;
      state.category = action.payload;
    },
  },
});

export default slice.reducer;

// ----------------------------------------------------------------------

const buildListParams = (venueId, params = {}) => ({
  venueId,
  page: "1",
  limit: "100000000",
  status: "active",
  // channel: "POS",
  ...params,
});

const getCategoryRealId = (category) => {
  return (
    getResolvedId(category?.categoryId) ||
    getResolvedId(category?.category) ||
    getResolvedId(category)
  );
};

const getProductRealId = (product) => {
  return (
    getResolvedId(product?.productId) ||
    getResolvedId(product?.product) ||
    getResolvedId(product?.itemId) ||
    getResolvedId(product?.item) ||
    getResolvedId(product)
  );
};

const normalizeCategory = (category) => {
  const id = getCategoryRealId(category);
  const scopeId = getResolvedId(category);

  return {
    ...category,

    id,
    _id: category?._id || id,

    scopeId,
    categoryScopeId: scopeId,

    parentCategoryId: getResolvedId(category?.parentCategoryId),
    categoryLevel: Number(category?.categoryLevel || 1),
    order: Number(category?.order || 0),

    name: getLocalizedText(
      category?.name ||
        category?.categoryId?.name ||
        category?.category?.name,
      ""
    ),

    description: getLocalizedText(
      category?.description ||
        category?.categoryId?.description ||
        category?.category?.description,
      ""
    ),

    items: [],
  };
};

const getProductCategoryIds = (product) => {
  const ids = [];

  if (Array.isArray(product?.categories)) {
    product.categories.forEach((category) => {
      const resolvedId = getResolvedId(category);
      if (resolvedId) ids.push(resolvedId);
    });
  }

  if (Array.isArray(product?.categoryIds)) {
    product.categoryIds.forEach((categoryId) => {
      const resolvedId = getResolvedId(categoryId);
      if (resolvedId) ids.push(resolvedId);
    });
  }

  const directCategoryId =
    getResolvedId(product?.categoryId) ||
    getResolvedId(product?.category);

  if (directCategoryId) {
    ids.push(directCategoryId);
  }

  return [...new Set(ids.map((id) => String(id)))];
};

const getFirstScope = (scopes = []) => {
  if (!Array.isArray(scopes) || !scopes.length) return {};

  return scopes[0] || {};
};

const getChoiceGroupIds = (value = {}) => {
  const choiceGroups = value?.choiceGroups || value?.choiceGroup || [];

  if (!Array.isArray(choiceGroups)) return [];

  return choiceGroups
    .map((choiceGroup) => getResolvedId(choiceGroup))
    .filter(Boolean);
};

const normalizeVariant = (variant = {}) => {
  const scope = getFirstScope(variant?.scopes);
  const variantName = getLocalizedText(variant?.name, "");
  const variantDescription = getLocalizedText(variant?.description, "");
  const choiceGroupIds = getChoiceGroupIds(variant);

  return {
    ...variant,

    id: getResolvedId(variant),
    _id: variant?._id || getResolvedId(variant),

    name:
      typeof variantName === "object"
        ? variantName?.en || variantName?.other_language || ""
        : variantName,

    description:
      typeof variantDescription === "object"
        ? variantDescription?.en || variantDescription?.other_language || ""
        : variantDescription,

    price: scope?.price ?? variant?.price ?? 0,
    foodPandaPrice: scope?.foodPandaPrice ?? variant?.foodPandaPrice ?? 0,
    quantity: scope?.quantity ?? variant?.quantity ?? 0,
    quantityUnit: scope?.quantityUnit ?? variant?.quantityUnit ?? "",
    status: scope?.status || variant?.status || "active",

    choiceGroup: choiceGroupIds,
    choiceGroups: choiceGroupIds,
  };
};

const normalizeProduct = (product) => {
  const id = getProductRealId(product);
  const categoryIds = getProductCategoryIds(product);
  const choiceGroupIds = getChoiceGroupIds(product);

  const productName = getLocalizedText(product?.name, "");
  const productDescription = getLocalizedText(product?.description, "");

  return {
    ...product,

    id,
    _id: product?._id || id,

    productId: id,
    itemId: id,

    categoryId: categoryIds[0] || null,
    categoryIds,
    categories: categoryIds,

    name:
      typeof productName === "object"
        ? productName?.en || productName?.other_language || ""
        : productName,

    description:
      typeof productDescription === "object"
        ? productDescription?.en || productDescription?.other_language || ""
        : productDescription,

    photoURL: product?.photoURL || "",

    price: product?.scope?.price ?? 0,
    foodPandaPrice: product?.scope?.foodPandaPrice ?? 0,

    quantity: product?.scope?.quantity ?? 0,
    quantityUnit: product?.scope?.quantityUnit || "",

    hasVariant: product?.hasVariant ?? false,
    isKitchenItem: product?.isKitchenItem ?? false,
    isSaleable: product?.isSaleable ?? false,
    associateChoiceGroupWithPriceVariant:
      product?.associateChoiceGroupWithPriceVariant ?? false,

    choiceGroup: choiceGroupIds,
    choiceGroups: choiceGroupIds,

    variants: Array.isArray(product?.variants)
      ? product.variants.map(normalizeVariant)
      : [],

    status: product?.scope?.status || product?.status || "active",
  };
};

const buildTerminalCategories = (categories = [], products = []) => {
  const normalizedCategories = categories.map(normalizeCategory);
  const normalizedProducts = products.map(normalizeProduct);

  return normalizedCategories.map((category) => ({
    ...category,
    items: normalizedProducts.filter((product) =>
      product.categoryIds.some(
        (categoryId) => String(categoryId) === String(category.id)
      )
    ),
  }));
};

// ----------------------------------------------------------------------

export function getCategories(venueId, params = {}) {
  return async (dispatch) =>
    handleApiRequest({
      dispatch,
      startLoading: slice.actions.startLoading,
      hasError: slice.actions.hasError,
      request: async () => {
        const response = await apiGet(
          CATEGORY_ENDPOINT,
          buildListParams(venueId, params)
        );

        const categories = getResults(response).map(normalizeCategory);

        dispatch(slice.actions.getCategoriesSuccess(categories));

        return {
          status: 200,
          data: categories,
        };
      },
    });
}

export function getTerminalCategories(
  venueId,
  isAvailableOnPos,
  posCart,
  params = {}
) {
  return async (dispatch) =>
    handleApiRequest({
      dispatch,
      startLoading: slice.actions.startLoading,
      hasError: slice.actions.hasError,
      request: async () => {
        const [categoriesResponse, productsResponse] = await Promise.all([
          apiGet(TERMINAL_CATEGORY_ENDPOINT, { venueId }),
          apiGet(TERMINAL_PRODUCT_ENDPOINT, { venueId }),
        ]);

        const categories = getResults(categoriesResponse);
        const products = getResults(productsResponse);

        const terminalCategories = buildTerminalCategories(categories, products);

        dispatch(slice.actions.getTerminalCategoriesSuccess(terminalCategories));

        return {
          status: 200,
          data: terminalCategories,
        };
      },
    });
}

// ----------------------------------------------------------------------

export function getCategory(categoryId, venueId, params = {}) {
  return async (dispatch) =>
    handleApiRequest({
      dispatch,
      startLoading: slice.actions.startLoading,
      hasError: slice.actions.hasError,
      request: async () => {
        const response = await apiGet(`${CATEGORY_ENDPOINT}/${categoryId}`, {
          venueId,
          status: "active",
          // channel: "POS",
          ...params,
        });

        const category = getResource(response, "category");
        const normalizedCategory = normalizeCategory(category);

        dispatch(slice.actions.getCategorySuccess(normalizedCategory));

        return {
          status: 200,
          data: normalizedCategory,
        };
      },
    });
}
